module.exports = __webpack_public_path__ + "static/media/we_love_omnicode.710e1c77.png";